/**
 * Format an ISO date string or Date in the given IANA timezone.
 * Used for tenant-consistent time display across the app.
 * @param {string|Date} isoStringOrDate - ISO string or Date instance
 * @param {string} timezone - IANA timezone (e.g. 'Asia/Shanghai', 'America/Los_Angeles')
 * @param {{ dateStyle?: string, timeStyle?: string }} options - Intl options
 * @returns {string} Formatted date/time string, or '-' if invalid
 */
export function formatInTenantTz(isoStringOrDate, timezone = 'Asia/Shanghai', options = {}) {
  if (isoStringOrDate == null || isoStringOrDate === '') return '-';
  const date = typeof isoStringOrDate === 'string' ? new Date(isoStringOrDate) : isoStringOrDate;
  if (Number.isNaN(date.getTime())) return '-';
  const defaultOpts = { dateStyle: 'short', timeStyle: 'short', timeZone: timezone };
  const opts = { ...defaultOpts, ...options };
  try {
    return new Intl.DateTimeFormat(undefined, opts).format(date);
  } catch {
    return date.toLocaleString();
  }
}
